import { useProgress } from '@react-three/drei'
import { useState, useEffect } from 'react'

export default function CustomLoader() {
  const { progress, active } = useProgress()
  const [show, setShow] = useState(true)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    if (!active && progress === 100) {
      // Start fade out after loading completes
      const fadeTimer = setTimeout(() => setFadeOut(true), 400)
      // Remove from DOM after fade animation
      const removeTimer = setTimeout(() => setShow(false), 1400)
      return () => {
        clearTimeout(fadeTimer)
        clearTimeout(removeTimer)
      }
    }
  }, [active, progress])

  if (!show) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      background: '#000000',
      zIndex: 9999,
      opacity: fadeOut ? 0 : 1,
      transition: 'opacity 1s ease',
      pointerEvents: fadeOut ? 'none' : 'all',
    }}>
      {/* Brand text */}
      <p style={{
        fontFamily: "'Barlow Condensed', sans-serif",
        fontSize: '1.2em',
        letterSpacing: '0.3em',
        color: 'rgba(255, 255, 255, 0.5)',
        textTransform: 'uppercase',
        margin: 0,
        fontWeight: 300,
      }}>
        Spiderman <span style={{ color: '#cc1a1a', fontWeight: 500 }}>Black</span>
      </p>

      {/* Line loader */}
      <div style={{
        width: '180px',
        height: '1px',
        background: 'rgba(255, 255, 255, 0.08)',
        borderRadius: '1px',
        overflow: 'hidden',
        position: 'relative',
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #cc1a1a, #ff3333)',
          borderRadius: '1px',
          transition: 'width 0.4s ease',
          boxShadow: '0 0 8px rgba(200, 30, 30, 0.6)',
        }} />
      </div>

      {/* Percentage */}
      <p style={{
        fontFamily: "'Barlow Condensed', sans-serif",
        fontSize: '0.75em',
        letterSpacing: '0.15em',
        color: 'rgba(255, 255, 255, 0.25)',
        margin: 0,
        fontWeight: 300,
        fontVariantNumeric: 'tabular-nums',
      }}>
        {Math.round(progress)}%
      </p>
    </div>
  )
}
